import { render, staticRenderFns } from "./ThemeLogo.vue?vue&type=template&id=3c0629cb&scoped=true&"
import script from "./ThemeLogo.vue?vue&type=script&lang=js&"
export * from "./ThemeLogo.vue?vue&type=script&lang=js&"
import style0 from "./ThemeLogo.vue?vue&type=style&index=0&id=3c0629cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0629cb",
  null
  
)

export default component.exports